var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoveToList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8889 14.3926V15.2814H22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5976 15.2812H15.6953",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.94 3.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 12.9921V8.08984",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.94 3.94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 7.38887V6.5H14.9963",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3965 6.5H21.2988",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.94 3.94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.5H22.8889V7.38887",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8887 8.78906V13.6917",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.94 3.94"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88867 13.7188H15.67V22.5001H6.88867V13.7188Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6367 13.7545L18.1373 11.2539V13.6051",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1371 11.2539H15.8008",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToList);
export default __webpack_public_path__ + "static/media/MoveToList.eef49900c1006a1389184649449b8180.svg";
export { ForwardRef as ReactComponent };